export default {
    namespaced: true,
    state: {
        history: []
    },
    actions: {
        push ({commit, rootState}, data) {
            commit('add', {
                ...data,
                time: rootState.control.time
            })
        },
        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        add (state, data) {
            state.history.unshift(data)
        },
        reset (state) {
            state.history = []
        }
    }
}
